// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { apiClient } from './client';

export interface LicenseSummary {
  readonly firmCode: string;
  readonly plan: string;
  readonly planName?: string;
  readonly modules: string[];
  readonly apps?: string[];
  readonly maxUsers: number;
  readonly maxCompanies: number;
  readonly expiryDate: string;
  readonly isActive: boolean;
  readonly isSuspended: boolean;
  readonly isReadonly: boolean;
  readonly suspendedReason?: string;
  readonly daysUntilExpiry?: number;
  readonly billingCycle?: string;
  /** Kurulum paketi: shared | dedicated | onprem. onprem'de bulut arayüzü ürün verisi göstermez. */
  readonly deploymentModel?: string;
}

export const licenseService = {
  async getInfo(): Promise<LicenseSummary | null> {
    try {
      const { data } = await apiClient.get<LicenseSummary>('/api/auth/license-info');
      return data;
    } catch (e: unknown) {
      const err = e as { response?: { status?: number } };
      if (err.response?.status === 401 || err.response?.status === 404) return null;
      throw e;
    }
  },
};
